import React from "react";

function TopActionButtons({ setShowInvestModal, setShowPartnerModal }) {
  return (
    <div className="container-fluid ps-4 pe-4" id="dashboardRoot">
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-between py-2 my-2 border border-primary">
          <div className="col text-start">
            <div
              className="btn btn-primary"
              onClick={() => setShowInvestModal(true)}
            >
              Add Invesment
            </div>
          </div>
          <div className="col text-end">
            <div
              className="btn btn-warning"
              onClick={() => setShowPartnerModal(true)}
            >
              Add Partner
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopActionButtons;
